import { Card } from '@wajeez-web/components/ui';

const DashboardSkeleton = () => {
  return (
    <div className="space-y-4">
      <div role="status" className="animate-pulse">
        <div className="flex space-s-2 items-center ">
          <div
            className=" w-8 h-8 rounded-full bg-gray-200 dark:bg-gray-700"
            aria-hidden="true"
          ></div>
          <div className="w-28 h-6 bg-gray-200 rounded-md dark:bg-gray-700 "></div>
        </div>
        <span className="sr-only">Loading...</span>
      </div>
      <div className="grid grid-cols-4 gap-3">
        <Card>
          <div role="status" className="animate-pulse">
            <div className="flex space-s-2 items-center ">
              <div
                className=" w-8 h-8 rounded-full bg-gray-200 dark:bg-gray-700"
                aria-hidden="true"
              ></div>
              <div className="w-28 h-6 bg-gray-200 rounded-md dark:bg-gray-700 "></div>
            </div>
            <span className="sr-only">Loading...</span>
          </div>
        </Card>
        <Card>
          <div role="status" className="animate-pulse">
            <div className="flex space-s-2 items-center ">
              <div
                className=" w-8 h-8 rounded-full bg-gray-200 dark:bg-gray-700"
                aria-hidden="true"
              ></div>
              <div className="w-28 h-6 bg-gray-200 rounded-md dark:bg-gray-700 "></div>
            </div>
            <span className="sr-only">Loading...</span>
          </div>
        </Card>
        <Card>
          <div role="status" className="animate-pulse">
            <div className="flex space-s-2 items-center ">
              <div
                className=" w-8 h-8 rounded-full bg-gray-200 dark:bg-gray-700"
                aria-hidden="true"
              ></div>
              <div className="w-28 h-6 bg-gray-200 rounded-md dark:bg-gray-700 "></div>
            </div>
            <span className="sr-only">Loading...</span>
          </div>
        </Card>
        <Card>
          <div role="status" className="animate-pulse">
            <div className="flex space-s-2 items-center ">
              <div
                className=" w-8 h-8 rounded-full bg-gray-200 dark:bg-gray-700"
                aria-hidden="true"
              ></div>
              <div className="w-28 h-6 bg-gray-200 rounded-md dark:bg-gray-700 "></div>
            </div>
            <span className="sr-only">Loading...</span>
          </div>
        </Card>
      </div>
      <Card>
        <div className="space-y-4">
          <div role="status" className="animate-pulse">
            <div className="flex space-s-2 items-center ">
              <div className="w-28 h-6 bg-gray-200 rounded-md dark:bg-gray-700 "></div>
            </div>
            <span className="sr-only">Loading...</span>
          </div>

          <div
            role="status"
            className="flex justify-center items-center w-full h-56 bg-gray-300 rounded-lg animate-pulse dark:bg-gray-700"
          >
            <div
              className="w-full h-80 text-gray-200 dark:text-gray-600"
              aria-hidden="true"
            ></div>
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </Card>
      <div className="grid grid-cols-4 gap-3">
        <div className="col-span-1 h-full">
          <Card>
            <div className="space-y-4">
              <div role="status" className="animate-pulse">
                <div className="flex space-s-2 items-center ">
                  <div className="w-28 h-6 bg-gray-200 rounded-md dark:bg-gray-700 "></div>
                </div>
                <span className="sr-only">Loading...</span>
              </div>
              <div role="status" className="animate-pulse space-y-1">
                <div className="flex space-s-2 items-center ">
                  <div
                    className=" w-8 h-8 rounded-full bg-gray-200 dark:bg-gray-700"
                    aria-hidden="true"
                  ></div>
                  <div className="w-28 h-4 bg-gray-200 rounded-md dark:bg-gray-700 "></div>
                </div>
                <div className="flex space-s-2 items-center ">
                  <div className=" w-8 h-8 " aria-hidden="true"></div>
                  <div className="w-full h-3 bg-gray-200 rounded-md dark:bg-gray-700 "></div>
                </div>
                <span className="sr-only">Loading...</span>
              </div>
              <div role="status" className="animate-pulse space-y-1">
                <div className="flex space-s-2 items-center ">
                  <div
                    className=" w-8 h-8 rounded-full bg-gray-200 dark:bg-gray-700"
                    aria-hidden="true"
                  ></div>
                  <div className="w-28 h-4 bg-gray-200 rounded-md dark:bg-gray-700 "></div>
                </div>
                <div className="flex space-s-2 items-center ">
                  <div className=" w-8 h-8 " aria-hidden="true"></div>
                  <div className="w-full h-3 bg-gray-200 rounded-md dark:bg-gray-700 "></div>
                </div>
                <span className="sr-only">Loading...</span>
              </div>
              <div role="status" className="animate-pulse space-y-1">
                <div className="flex space-s-2 items-center ">
                  <div
                    className=" w-8 h-8 rounded-full bg-gray-200 dark:bg-gray-700"
                    aria-hidden="true"
                  ></div>
                  <div className="w-28 h-4 bg-gray-200 rounded-md dark:bg-gray-700 "></div>
                </div>
                <div className="flex space-s-2 items-center ">
                  <div className=" w-8 h-8 " aria-hidden="true"></div>
                  <div className="w-full h-3 bg-gray-200 rounded-md dark:bg-gray-700 "></div>
                </div>
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </Card>
        </div>

        <div className="col-span-3">
          <Card>
            <div className="space-y-4">
              <div role="status" className="animate-pulse">
                <div className="flex space-s-2 items-center ">
                  <div className="w-28 h-6 bg-gray-200 rounded-md dark:bg-gray-700 "></div>
                </div>
                <span className="sr-only">Loading...</span>
              </div>

              <div
                role="status"
                className="flex justify-center items-center w-full h-full bg-gray-300 rounded-lg animate-pulse dark:bg-gray-700"
              >
                <div
                  className="w-full h-[236px] text-gray-200 dark:text-gray-600"
                  aria-hidden="true"
                ></div>
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default DashboardSkeleton;
